"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var RejectIcon = function RejectIcon(_ref) {
  var color = _ref.color,
    width = _ref.width,
    height = _ref.height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    className: className,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M18.9189189,10 C18.9189189,5.07579377 14.9251258,1.08108108 10,1.08108108 C5.07487418,1.08108108 1.08108108,5.07579377 1.08108108,10 C1.08108108,14.9272606 5.07319901,18.9189189 10,18.9189189 C14.926801,18.9189189 18.9189189,14.9272606 18.9189189,10 Z M9.23606108,10 L6.75679471,12.4787655 C6.54567917,12.6898384 6.5456446,13.0320898 6.75671748,13.2432053 C6.96779037,13.4543208 7.31004171,13.4543554 7.52115724,13.2432825 L10.0005781,10.7643626 L12.4799989,13.2432825 C12.6911144,13.4543554 13.0333658,13.4543208 13.2444387,13.2432053 C13.4555116,13.0320898 13.455477,12.6898384 13.2443614,12.4787655 L10.7650951,10 L13.2441302,7.5214657 C13.4552458,7.31039281 13.4552803,6.96814147 13.2442074,6.75702594 C13.0331346,6.5459104 12.6908832,6.54587583 12.4797677,6.75694872 L10.0005781,9.23563747 L7.52138848,6.75694872 C7.31027294,6.54587583 6.9680216,6.5459104 6.75694872,6.75702594 C6.54587583,6.96814147 6.5459104,7.31039281 6.75702594,7.5214657 L9.23606108,10 Z M20,10 C20,15.5243531 15.5238377,20 10,20 C4.47616227,20 0,15.5243531 0,10 C0,4.47878489 4.47775386,0 10,0 C15.5222461,0 20,4.47878489 20,10 Z"
  }));
};
var defaultProps = {
  color: _constants.colors.darkRed,
  width: 20,
  height: 20
};
RejectIcon.defaultProps = defaultProps;
var _default = exports["default"] = RejectIcon;